//로컬(localhost)에서 서버 없이 화면만 볼 때 쓰는 목 설정 — /winterpay?preview=1[&stage=paid|transfer|uploaded|waiting|expired|soon|sample]
//실제 금액표의 원본은 서버 peetsunbaeserver/src/data/winterRates.ts. 여기 값은 화면 확인용 복사본이라 운영 판단에 쓰지 말 것.
import { WinterConfig, calcCustomerPrice, toDate } from "./price";
import type { LinkInfo } from "./index";

const sp = (student: number | null) => ({ p1: student, p4: student, p2: null, p3: null });
const bank = { accountName: "(주)수능선배 (미리보기)", bankName: "신한은행", accountNumber: "000-000-000000" };

export const isPreviewMode = () => {
    try {
        const h = window.location.hostname;
        return (h === "localhost" || h === "127.0.0.1") && new URLSearchParams(window.location.search).get("preview") === "1";
    } catch (e) { return false; }
};

export const previewConfig = (): WinterConfig => {
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, "0");
    return {
        rates: {
            prices: {
                gangnam: { base: 790000, periods: sp(null) }, daechi: { base: 790000, periods: sp(null) }, songpa: { base: 790000, periods: sp(null) },
                bundang: { base: 790000, periods: sp(null) }, sinchon: { base: 790000, periods: sp(null) }, daegu: { base: 790000, periods: sp(null) },
                centum: { base: 750000, periods: sp(550000) }, gangdong: { base: 750000, periods: sp(550000) },
                dongtan: { base: 720000, periods: sp(520000) }, hanam: { base: 720000, periods: sp(520000) }, gimpo: { base: 690000, periods: sp(490000) },
            },
            periods: [
                { id: "p1", name: "학기중", target: "student", ranges: [{ start: "2026-03-02", end: "2026-07-17" }, { start: "2026-08-17", end: "2026-11-22" }] },
                { id: "p4", name: "프리윈터(재학생)", target: "student", ranges: [{ start: "2026-11-23", end: "2026-12-27" }] },
                { id: "p2", name: "프리윈터", target: "all", ranges: [{ start: "2026-11-23", end: "2026-12-27" }] },
                { id: "p3", name: "정규윈터", target: "all", ranges: [{ start: "2026-12-28", end: "2027-02-28" }] },
            ],
            benefits: [
                { id: "b1", name: "조기 등록", type: "until", dates: ["2026-11-19"], pct: 5, periodIds: ["p4", "p2", "p3"] },
                { id: "b2", name: "설명회 당일 등록", type: "on", dates: ["2026-10-18", "2026-11-15"], pct: 5, periodIds: ["p4", "p2", "p3"] },
            ],
        },
        programs: [
            { pid: "p2", name: "프리윈터", startFrom: "2026-11-23", startTo: "2026-12-26", ends: ["2026-11-30", "2026-12-27", "2027-01-31", "2027-02-28"] },
            { pid: "p3", name: "정규윈터", startFrom: "2026-12-28", startTo: "2027-01-04", ends: ["2027-01-31", "2027-02-28"], fixedStart: { branches: ["gangnam", "daechi"], date: "2026-12-28" } },
        ],
        branches: [
            ["gangnam", "강남점"], ["daechi", "대치점"], ["songpa", "송파점"], ["bundang", "분당점"], ["sinchon", "신촌점"], ["daegu", "수성점"],
            ["centum", "센텀점"], ["gangdong", "강동점"], ["dongtan", "동탄점"], ["hanam", "하남점"], ["gimpo", "김포점"],
        ].map(([english, korean]) => ({ english, korean, bankinfo: bank })),
        seatPerk: { lastStart: "2026-12-12" },
        now: now.getTime(),
        today: now.getFullYear() + "-" + pad(now.getMonth() + 1) + "-" + pad(now.getDate()),
    };
};

//stage 별 링크 상태. expired 는 null(차단 화면), soon 은 만료 15초 전
export const previewLink = (cfg: WinterConfig): LinkInfo | null => {
    const stage = new URLSearchParams(window.location.search).get("stage") || "";
    if (stage === "expired") return null;
    const due = stage === "soon" ? Date.now() + 15 * 1000 : Date.now() + 5 * 3600 * 1000 + 37 * 60 * 1000;
    const base: LinkInfo = { id: 0, location: null, studentType: null, dueDate: due, status: "open", paidAt: null, program: null, startDate: null, endDate: null, price: null, paymentMethod: null, whichCertify: null, studentName: null, gender: null, studentPhoneNumber: null, parentPhoneNumber: null, newPayLinkId: null, newPayLinkCode: null, imageSrc: null, shortUrl: null, priceDetail: null };
    if (stage === "sample") return { ...base, location: "daechi", dueDate: new Date("2026-10-03T20:00:00").getTime(), sample: true };
    if (!stage || stage === "soon") return base;
    const r = calcCustomerPrice(cfg.rates, "general", "gangdong", toDate("2026-11-25"), toDate("2026-12-27"), cfg.today);
    const filled: LinkInfo = {
        ...base, location: "gangdong", studentType: "general", program: "p2", startDate: "2026-11-25", endDate: "2026-12-27",
        price: r.price, priceDetail: { price: r.price, original: r.original, usedBenefits: r.usedBenefits },
        studentName: "김수능", gender: "male", studentPhoneNumber: "01012345678", parentPhoneNumber: "01087654321", whichCertify: "parent",
        newPayLinkId: 1, newPayLinkCode: 511,
    };
    const sample = "data:image/svg+xml;utf8," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="600" height="900"><rect width="600" height="900" fill="#F1F2F4"/><text x="300" y="450" font-size="28" text-anchor="middle" fill="#6B7684">이체 내역 캡처 (미리보기)</text></svg>');
    if (stage === "paid") return { ...filled, status: "paid", paymentMethod: "payteacher", paidAt: Date.now() - 60000 };
    if (stage === "transfer") return { ...filled, status: "transferUploaded", paymentMethod: "withdrawal" };
    if (stage === "uploaded") return { ...filled, status: "transferUploaded", paymentMethod: "withdrawal", imageSrc: sample };
    if (stage === "waiting") return { ...filled, status: "transferFinished", paymentMethod: "withdrawal", imageSrc: sample };
    return base;
};
